export function initHubSpot() {
  const script = document.createElement("script");

  script.src = "//js-eu1.hs-scripts.com/27209674.js";
  script.async = true;
  script.defer = true;

  document.body.appendChild(script);
}
